import { useState } from "react";
import { useToast } from "@chakra-ui/react";
import { useLang } from '../../../Hooks';
import {
  updateProjectFile,
  deleteProjectFile,
} from "../../../Services/api";

export default function useFolderFilesManager() {
  const toast = useToast();
  const { texts } = useLang(); 
  
  const notify = (status, message) => {
    toast({
      title: message,
      status: status,
      duration: 3000,
      isClosable: true,
      position: 'top',
    });
  };
  
  const [isUpdateLoading, setIsUpdateLoading] = useState(false);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);

  const onUpdate = async (form) => {
    setIsUpdateLoading(true);
    try {
      const { data } = await updateProjectFile(form.FileId, { FileName: form.FileName });
      notify("success", data.message || texts?.fileManager?.fileUpdated || "File updated successfully");
      return true; 
    } catch (err) {
      notify("error", err.response?.data?.message || texts?.fileManager?.failedToUpdateFile || "Failed to update file");
      return false; 
    } finally {
      setIsUpdateLoading(false);
    }
  };

  const onDelete = async (form) => {
    setIsDeleteLoading(true);
    try {
      const { data } = await deleteProjectFile(form.FileId);
      notify("success", data.message || texts?.fileManager?.fileDeleted || "File deleted successfully");
      return true; 
    } catch (err) {
      notify("error", err.response?.data?.message || texts?.fileManager?.failedToDeleteFile || "Failed to delete file");
      return false;
    } finally {
      setIsDeleteLoading(false);
    }
  };

  const OnSubmit = async (form) => {
    if (form.Tab === "EditFile") {
      return await onUpdate(form); 
    } else if (form.Tab === "DeleteFile") {
      return await onDelete(form);
    }
    return false;
  };

  return {
    OnSubmit,
    IsUpdateFolderFilesLoading: isUpdateLoading,
    IsDeleteFolderFilesLoading: isDeleteLoading,
  };
}